import { defineComponent as n } from "vue";
const e = n({
  name: "MsAnchor",
  props: {
    id: String
  }
});
export {
  e as default
};
